//
//
//
//
//
//
//

const textObj = {
  0: '未开始',
  1: '进行中',
  2: '已结束',
};
const colorObj = {
  0: '#BBBBBB',
  1: '#2DA55D',
  2: '#BBBBBB',
};
export default {
  props: {
    status: {
      type: String,
    },
    mark: {
      type: String,
    },
  },
  components: {},
  computed: {
    text() {
      return textObj[this.status];
    },
    statue_color() {
      return colorObj[this.status];
    },
  },
};
